import { render, staticRenderFns } from "./ProductList.vue?vue&type=template&id=72803338&scoped=true"
import script from "./ProductList.vue?vue&type=script&lang=ts"
export * from "./ProductList.vue?vue&type=script&lang=ts"
import style0 from "./ProductList.vue?vue&type=style&index=0&id=72803338&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72803338",
  null
  
)

export default component.exports